import { Check } from '@mui/icons-material';
import {
  Button,
  Card,
  CardContent,
  Grid,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';
import { useState } from 'react';
import { updateInstallationTimeline } from '../../services/CustomerService';
import { InstallationTimeline } from '../../utils/app.enums';

export default function SolarSearch({ propertyDetails }) {
  const [selectedOption, setSelectedOption] = useState(null);
  const theme = useTheme();

  const options = [
    {
      id: 1,
      name: 'In 1 months',
      value: InstallationTimeline.ONE_MONTH,
      details: 'as soon as possible',
    },
    {
      id: 2,
      name: '1-3 months',
      value: InstallationTimeline.ONE_THREE_MONTHS,
      details: 'in no hurry to install',
    },
    {
      id: 3,
      name: 'Just researching',
      value: InstallationTimeline.THREE_PLUS_MONTHS,
      details: 'help me with research',
    },
  ];

  const handleCardClick = (index) => {
    setSelectedOption(selectedOption === index ? null : index);
  };

  const handleConfirm = async () => {
    if (selectedOption !== null) {
      const selectedOptionDetails = options[selectedOption];
      await updateInstallationTimeline(
        propertyDetails,
        selectedOptionDetails.value,
      );
      window.location.reload();
    }
  };

  return (
    <Stack padding='0px !important'>
      <Typography
        sx={{
          fontSize: {
            xs: theme.typography.h5.fontSize,
            md: theme.typography.h4.fontSize,
          },
          fontWeight: 'bold',
          marginTop: '10px',
        }}
      >
        Solar search is{' '}
        <span style={{ color: theme.palette.warning.secondary }}>off</span>
      </Typography>
      <Typography
        sx={{
          fontSize: {
            xs: theme.typography.h6.fontSize,
            md: theme.typography.h5.fontSize,
          },
          fontWeight: 'bold',
          marginTop: '10px',
        }}
      >
        Looking for solar?
      </Typography>
      <Typography
        sx={{
          fontSize: {
            xs: theme.typography.h6.fontSize,
            md: theme.typography.h5.fontSize,
          },
          fontWeight: 'bold',
          mb: '10px',
        }}
      >
        Update tentative timeline
      </Typography>
      <Stack width={'100%'} gap={'8px'}>
        {options.map((option, index) => (
          <Card
            key={option.id}
            sx={{
              backgroundColor:
                selectedOption === index
                  ? theme.palette.secondary.lighter
                  : theme.palette.background.paper,
              cursor: 'pointer',
              width: '100%',
              borderRadius: '16px',
              border: '1px solid lightgray',
              boxShadow: 'none',
            }}
            onClick={() => handleCardClick(index)}
          >
            <CardContent>
              <Typography sx={{ fontWeight: 'bold', paddingBottom: '4px' }}>
                <Typography
                  variant='h6'
                  component='span'
                  sx={{ color: 'primary.main' }}
                  fontWeight='bold'
                >
                  {option.name}
                </Typography>
              </Typography>
              <Typography variant='subtitle2'>{option.details}</Typography>
              {selectedOption === index && (
                <>
                  <Grid container mt={2} justifyContent={'flex-end'}>
                    <Button
                      variant='contained'
                      onClick={handleConfirm}
                      startIcon={<Check />}
                    >
                      Confirm
                    </Button>
                  </Grid>
                </>
              )}
            </CardContent>
          </Card>
        ))}
      </Stack>
    </Stack>
  );
}
